import React from 'react';

const InputUi = ({ label, value, datafunction, placeholder, isInput = true, fieldClass = '', onKeyDown }) => {
    if (isInput) {
        return (
            <div className="flex flex-col gap-2">
                <p className="text-sm font-medium text-[var(--text)]">{label}</p>
                <input
                    type="text"
                    value={value}
                    onChange={datafunction}
                    onKeyDown={onKeyDown}
                    placeholder={placeholder}
                    className={`px-3 py-2 border border-[var(--border)] rounded-lg bg-[var(--surface)] text-[var(--text)] ${fieldClass}`}
                />
            </div>
        );
    } else {
        return (
            <div className="flex flex-col gap-2">
                <p className="text-sm font-medium text-[var(--text)]">{label}</p>
                <textarea
                    value={value}
                    onChange={datafunction}
                    onKeyDown={onKeyDown}
                    placeholder={placeholder}
                    className={`px-3 py-2 border border-[var(--border)] rounded-lg bg-[var(--surface)] text-[var(--text)] resize-none ${fieldClass}`}
                />
            </div>
        );
    }
};

export default InputUi;
